module.exports = __webpack_public_path__ + "img/IMG_6258_L_Foamcore.fb280a2b.jpg";